export const ZERO_AFTER_COMMA = new RegExp(/^\d+(\.(0+))$/);

export const LAST_CHARACTER_IS_NUMBER = new RegExp(/^\d+(\.(\d))\d+$/);

export const NUMBER_CHECK_REGEXP = new RegExp(/^\d+($|(\.|\,)(\d+|$))$/);

export default {
  ZERO_AFTER_COMMA,
  LAST_CHARACTER_IS_NUMBER,
  NUMBER_CHECK_REGEXP,
};
